module.exports = __webpack_public_path__ + "static/img/tiop.c0933773.png";